// Google Analytics 4 tracking functions
export const GA_TRACKING_ID = 'G-KNFDW44EHJ';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track page views
export const trackPageView = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track quiz-specific events
export const trackQuizEvent = (eventName, level, additionalData = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, {
      event_category: 'Quiz',
      event_label: level,
      ...additionalData,
    });
  }
};

// Track quiz completion
export const trackQuizCompletion = (level, hintsUsed, mistakes, timeSpent) => {
  trackQuizEvent('quiz_completed', level, {
    hints_used: hintsUsed,
    mistakes: mistakes,
    time_spent: timeSpent,
  });
};

// Track hint usage
export const trackHintUsage = (level, hintType) => {
  trackQuizEvent('hint_used', level, {
    hint_type: hintType,
  });
};

// Track correct answers
export const trackCorrectAnswer = (level, attempts) => {
  trackQuizEvent('correct_answer', level, {
    attempts: attempts,
  });
};

// Track incorrect answers
export const trackIncorrectAnswer = (level, attempts) => {
  trackQuizEvent('incorrect_answer', level, {
    attempts: attempts,
  });
};

// Track daily quiz start
export const trackDailyQuizStart = (date) => {
  trackQuizEvent('daily_quiz_started', 'all', {
    quiz_date: date,
  });
};

// Track theme Interaction
export const trackThemeInteraction = (theme) => {
  trackEvent('theme_viewed', 'Content', theme);
};

// Track stats view
export const trackStatsView = () => {
  trackEvent('stats_viewed', 'User', 'Statistics');
};

// Track dark mode toggle
export const trackDarkModeToggle = (isDarkMode) => {
  trackEvent('dark_mode_toggle', 'User', isDarkMode ? 'Dark' : 'Light');
};

// Track date picker usage
export const trackDatePickerUsage = (selectedDate) => {
  trackEvent('date_picker_used', 'User', selectedDate);
};

// Track feedback submission
export const trackFeedbackSubmission = (likes, dislikes) => {
  trackEvent('feedback_submitted', 'User', 'Quiz Feedback', likes + dislikes);
};

// Track share results
export const trackShareResults = (results) => {
  trackEvent('results_shared', 'User', 'Quiz Results', results);
};
